module.exports = __webpack_public_path__ + "img/app-logo.d35b3d48.png";